import { render, staticRenderFns } from "./ProfileSkeleton.vue?vue&type=template&id=e96c26d6&scoped=true"
import script from "./ProfileSkeleton.vue?vue&type=script&lang=js"
export * from "./ProfileSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ProfileSkeleton.vue?vue&type=style&index=0&id=e96c26d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96c26d6",
  null
  
)

export default component.exports